export enum MashProfile {
    FullBody = 'full-body',
    LightBody = 'light-body',
    MediumBody = 'medium-body',
}

export enum BeerType {
    Ale = 'ale',
    Laber = 'lager',
}

export enum YeastType {
    Ale = 'ale',
    Lager = 'lager',
}

export enum HopAdditionStage {
    Boil = 'boil',
    DryHop = 'dry-hop',
}
